import { Injectable, Injector, ErrorHandler } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,

    HttpEventType,
    HttpResponseBase
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, mergeMap, catchError } from 'rxjs/operators';
import { LgvAuth0Service } from '../services/lgv-auth0.service';
import { LgvClientAuthService } from '../services/lgv-client-auth.service';
import { LgvAuthMgrService } from '../services/lgv-auth-mgr.service';
import { environment as env } from '../../../environments/environment';

@Injectable()
export class LgvHttpInterceptor implements HttpInterceptor {
    constructor(private injector: Injector,
        private clientAuthService: LgvClientAuthService,
        private authMgrSvc: LgvAuthMgrService,
        private auth0Service: LgvAuth0Service) { }

    ShowError(err: HttpErrorResponse): boolean {
        let ignoreErrors = ['EXPIRED'];

        let strType = err.error.type.toString();
        let shouldSuppress = ignoreErrors.indexOf(strType) != -1;

        console.log('SHOULD SUPPRESS: ' + shouldSuppress);

        return !shouldSuppress;
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        //console.log('########## Interceptor ##########');
        //console.log(request.url);

        if (request.headers.has('Skip-Auth')) {
            const cleanRequest = request.clone({
                headers: request.headers.delete('Skip-Auth')
            });
            return next.handle(cleanRequest);
        }

        let isSecureClientUrl = request.url.toUpperCase().includes('LOANAPPLICATION');
        let useSecureClientToken = isSecureClientUrl && this.authMgrSvc.IsSecureClient;
        let useStdClientToken = !useSecureClientToken && (this.authMgrSvc.IsClient || this.clientAuthService.IsTestingBearerToken);
        let useInternalAuth0Token = this.authMgrSvc.IsAuth0;

        if (request.url.includes('api.batchdata.com')) {
            const authRequest = request.clone({
                setHeaders: { Authorization: `Bearer ${'BcKNMfolAmpGT5kcfYgq8f91tSb7zf0uozkDj7Em'}` }
            });
            return next.handle(authRequest);
        }

        //console.log();
        //console.log(`###  ${request.url.replace(env.LgvApiBaseUrl, '')}  | ${isSecureClientUrl}  |  ${useSecureClientToken}  |  ${useStdClientToken}  |  ${useInternalAuth0Token}`)
        //console.log();

        if (useSecureClientToken) {
            //console.log('########## Interceptor | SecureClient ##########');

            let t = this.authMgrSvc.secureClientToken;
            const authRequest = request.clone({
                setHeaders: { Authorization: `Bearer ${t}` }
            });

            return next.handle(authRequest).pipe(
                tap({
                    error: (err: any) => {
                        //if (err instanceof HttpErrorResponse) {

                        //    if (this.ShowError(err)) {
                        //        const appErrorHandler = this.injector.get(ErrorHandler);
                        //        appErrorHandler.handleError(err);
                        //    }
                        //}
                    }
                })
            );
        }
        else if (useStdClientToken) {
            let t = this.clientAuthService.ClientBearerToken$.value;

            //console.log('########## Interceptor | Client Auth - ' + t + ' | IsTestingBT: ' + this.clientAuthService.IsTestingBearerToken + ' ##########');

            const authRequest = request.clone({
                setHeaders: { Authorization: `Bearer ${t}` }
            });

            return next.handle(authRequest).pipe(
                tap({
                    error: (err: any) => {
                        //if (err instanceof HttpErrorResponse) {

                        //    if (this.ShowError(err)) {
                        //        const appErrorHandler = this.injector.get(ErrorHandler);
                        //        appErrorHandler.handleError(err);
                        //    }
                        //}
                    }
                })
            );
        }
        else if (useInternalAuth0Token) {
            //console.log('########## Interceptor | Auth0 ##########');

            if (useInternalAuth0Token) {
                return this.auth0Service.getTokenSilently$().pipe(
                    mergeMap((t: string) => {
                        const authRequest = request.clone({
                            setHeaders: { Authorization: `Bearer ${t}` }
                        });
                        return next.handle(authRequest);
                    })
                );
            }            
        }
        else {

            //console.log('#################### Interceptor | No Auth ####################');

            // Don't try to get a token if the user is not logged in
            //console.log('*** Inteceptor w/ no Auth ***');
            return next.handle(request).pipe(
                tap({
                    error: (err: any) => {
                        //if (err instanceof HttpErrorResponse) {

                        //    const appErrorHandler = this.injector.get(ErrorHandler);
                        //    appErrorHandler.handleError(err);
                        //}
                    }
                })
            );
        }
    }
}
